import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="11"
    viewBox="0 0 11 11"
    className={className}
  >
    <g fill="#fff" stroke={color} strokeWidth="1">
      <circle cx="5.5" cy="5.5" r="5.5" stroke="none" />
      <circle cx="5.5" cy="5.5" r="5" fill="none" />
    </g>
  </svg>
);
